// src/hooks/useWebsocketHandlers.ts
'use client'

import { IEvent, IServiceAppointments } from '@/service/types'
import { useRouter } from 'next/navigation'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Socket } from 'socket.io-client'
import { routes } from '../utils/routes'

export const useWebsocketHandlers = (socket: Socket) => {
  const [services, setServices] = useState<IServiceAppointments[]>([])
  const [clientId, setClientId] = useState('')
  const [eventData, setEventData] = useState<IEvent | null>(null)

  const router = useRouter()

  /*
    Handle incoming events from websocket server
  */
  useEffect(() => {
    const handleAppoinmentsUpdated = (data: IServiceAppointments[]) => {
      setServices(data)
    }

    const handleJoinedRoom = (data: {
      services: IServiceAppointments[]
      event: IEvent
      clientId: string
    }) => {
      const [_, realClientId] = data.clientId.split('VISITOR#')
      if (!realClientId) {
        console.error('Real client ID not found!')
        return
      }
      setClientId(realClientId)
      setEventData(data.event)
      setServices(data.services)
    }

    const handleSuccessfulBooking = (data: { bookingId: string; eventId: string }) => {
      router.push(routes.publicBookingSuccess(data.bookingId, data.eventId))
    }

    const handleErrorMessage = (data: { status: string; message: string }) => {
      if (data.status && data.status === 'WARN') {
        return toast.warn(data.message)
      } else {
        return toast.error(data.message)
      }
      // router.push(`/error?message=${encodeURIComponent(data.message)}`);
      // TODO: FIX LATER
      // router.push(`/message?message=${encodeURIComponent(data.message)}`);
    }

    if (clientId) {
      socket.on('appointmentsUpdated', handleAppoinmentsUpdated)
      socket.on('bookingSuccessful', handleSuccessfulBooking)
    }

    socket.on('errorMessage', handleErrorMessage)
    socket.on('joinedEventRoom', handleJoinedRoom)

    return () => {
      if (clientId) {
        socket.off('appointmentsUpdated', handleAppoinmentsUpdated)
        socket.off('bookingSuccessful', handleSuccessfulBooking)
      }

      socket.off('errorMessage', handleErrorMessage)
      socket.off('joinedEventRoom', handleJoinedRoom)
    }
  }, [socket, clientId, router])

  return { services, clientId, eventData }
}
